/* eslint-disable  @typescript-eslint/no-explicit-any */
import { ISupplierResponse } from "../models/Other";

export function convertSupplier(data: any): ISupplierResponse[] {
  return data?.map((item: any) => ({
    id: item.id,
    name: item.name,
  }))
}